import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

@Directive({
    selector: '[appFeatureFlag]',
    standalone: false
})
export class FeatureFlagDirective implements OnInit {
    // TODO: Is tis directive even used somewhere anymore?
    @Input() public appFeatureFlag: string;

    constructor(
        private tpl: TemplateRef<any>,
        private vcr: ViewContainerRef,
        private featureFlagService: FeatureFlagService
    ) {
    }

    ngOnInit() {
        const isEnabled = this.featureFlagService.isFeatureEnabled(this.appFeatureFlag);
        if (isEnabled) {
            this.vcr.createEmbeddedView(this.tpl);
        }
    }
}
